export default {
  code: '航司代码',
  nameCn: '中文名称',
  nameEn: '英文名称',
  iataCode: 'IATA代码',
  icaoCode: 'ICAO代码',
  CA: '国航CA',
  MU: '东航MU',
  CZ: '南航CZ',
  HU: '海航HU',
  '3U': '川航3U',
  CX: '国泰CX',
  KE: '大韩KE',
  NH: '全日空NH',
  JL: '日航JL',
  LH: '汉莎LH',
  AF: '法航AF',
  KL: '荷航KL',
  UA: '美联航UA',
  AA: '美航AA',
  DL: '达美DL',
  SQ: '新航SQ',
}
